import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme)=>({
    
    media: {
        height: 250,
        width: '100%',
        marginTop: '4.5%',
        clipPath: 'polygon(0 9%, 100% 0, 100% 94%, 0% 100%)',       
    },
    space: {
        paddingLeft: "4%",
        marginTop: "4%"
        
    },
    timeline: {
        padding: 0,
        position: 'relative',
        top: -45,
 
    },

}));